import axios from 'axios';

import { ConversationDto } from '../models/conversation.interface';
import { SubmitConversationFeedbackPayload, SubmitMessageFeedbackPayload } from '../models/message-feedback.interface';
import { RenterInventoryDto, UserTranscriptDto } from '../models/renter-overview.interface';

class ConversationService {
  async getByPropertyAndUser(propertyId: string, userId: string): Promise<ConversationDto[]> {
    return (await axios.get(`conversation/renter-chat-transcript/${propertyId}/${userId}`)).data;
  }

  /** The renter's GLOBAL conversation — every message across all their inquiries, in order. */
  async getUserTranscriptByEmail(email: string): Promise<UserTranscriptDto> {
    return (await axios.get(`conversation/user-transcript/${encodeURIComponent(email)}`)).data;
  }

  /** The renter's inquiries + proposed properties, as the inquiry router sees them. */
  async getRenterInventoryByEmail(email: string): Promise<RenterInventoryDto> {
    return (await axios.get(`conversation/renter-inventory/${encodeURIComponent(email)}`)).data;
  }

  /**
   * One inquiry's slice of the renter's thread. Relationship-gated (unlike getByPropertyAndEmail),
   * so it also works for promoted inquiries on other companies' properties.
   */
  async getInquiryTranscriptByEmail(email: string, conversationId: string): Promise<UserTranscriptDto> {
    return (await axios.get(`conversation/inquiry-transcript/${encodeURIComponent(email)}/${conversationId}`)).data;
  }

  async resumeConversation(propertyId: string, conversationId: string): Promise<void> {
    await axios.post(`conversation/emergency-stop/resume/${propertyId}/${conversationId}`);
  }

  async submitMessageFeedback(payload: SubmitMessageFeedbackPayload): Promise<void> {
    await axios.post('investor-message-feedback', payload);
  }

  async submitConversationFeedback(payload: SubmitConversationFeedbackPayload): Promise<void> {
    await axios.post('investor-conversation-feedback', payload);
  }
}

export default new ConversationService();
